<div class="products-list" *ngIf="products && products.length > 0">
    <div class="products-list__wrapper">
        <swiper-container
            #swiperRef
            class="products-list__swiper"
            init="false">
            <swiper-slide *ngFor="let product of products; trackBy: trackById" class="products-list__slide">
                <app-product-card [data]="product"></app-product-card>
            </swiper-slide>
        </swiper-container>

        <button
            type="button"
            class="products-list__nav products-list__nav--prev"
            (click)="prev()"
            *ngIf="showArrows"
            aria-label="Previous tour">
            <span aria-hidden="true">&#x2039;</span>
        </button>
        <button
            type="button"
            class="products-list__nav products-list__nav--next"
            (click)="next()"
            *ngIf="showArrows"
            aria-label="Next tour">
            <span aria-hidden="true">&#x203A;</span>
        </button>
    </div>
</div>
